<template>
	<CharacteristicEdit
		:value="value"
		:characteristic-items="meta.benefits"
		:characteristic-type="meta.benefitsType"
		title="Benefits"
		:nothing-allowed="{
			onlyOverall: true,
			overall: {
				inFan: true,
				text: 'Bei diesem Job gibt es keine Benefits'
			}
		}"
		:selected-items-config="{
			showExperience: false,
		}"
		label-type="job-profile"
		open-fan-button-alignment="left"
		open-fan-label="Hinzufügen"
		open-fan-label-with-selection="Bearbeiten"
		@input="$emit('input', $event)"
	/>
</template>

<script>
import CharacteristicEdit from "@/vue/characteristic/Edit";

export default {

	components: {
		CharacteristicEdit
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
	},
}
</script>
